import { render, staticRenderFns } from "./BoardClassActionsMenu.vue?vue&type=template&id=4efc764b&"
import script from "./BoardClassActionsMenu.vue?vue&type=script&lang=js&"
export * from "./BoardClassActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports